module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('form', {
    on: {
      "submit": _vm.createUsers
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('h5', [_vm._v("Information")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form-textarea', {
    attrs: {
      "label": "User Emails",
      "name": "emails",
      "validation": "required|emaillist"
    },
    model: {
      value: (_vm.emails),
      callback: function($$v) {
        _vm.emails = $$v
      },
      expression: "emails"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("* Note, when user goes to login for the first time they will need to enter their email \n                then click \"Trouble signing in?\" in order to reset their password through email. This \n                ensures password integrity and security for users.\n              ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b2d4003","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Users/CreateMultipleUsers.vue
// module id = 607
// module chunks = 1